import { put, takeLatest } from 'redux-saga/effects';
import { GET_BRANDS, GET_BRANDS_SUCCESS } from '@/store/types/brand';
import { onFailRequest } from '@/utils';
import { requestGetBrands } from '@/store/requests/brand';

function* getBrands({payload}) {
  try {
    const { data } = yield requestGetBrands(payload);
    yield put({ type: GET_BRANDS_SUCCESS, payload: data });
  } catch (error) {
    yield onFailRequest({ error });
  }
}

export default [takeLatest(GET_BRANDS, getBrands)];
